import { AxiosRequestConfig, AxiosInstance } from "axios";
import Qs from "qs";
import { CustomRequest } from "./request.d";
import openInstance from "./open.instance";
import nodeInstance from "./node.instance";
import { Custom, CustomHistory } from "@/axios/interfaces/custom";
import { Standard } from "@/axios/interfaces/standard";
import { Template, TemplateHistory } from "@/axios/interfaces/template";
import { Fragment, FragmentHistory } from "./interfaces/fragment";
import { RecycleBin } from "./interfaces/destroy";

const wrapRequest = function <REQ, RES>(
  wrapOptions: AxiosRequestConfig,
  // TODO 架构设计失误，有时间重新处理一下这里的类型
  format?: (data: any) => any, // eslint-disable-line
  instance: AxiosInstance = openInstance
) {
  return (options?: AxiosRequestConfig & REQ): Promise<RES> => {
    return instance(Object.assign(options || {}, wrapOptions)).then(
      (response) => {
        if (format) {
          return format(response);
        }
        return response;
      }
    );
  };
};

/**
 * params 参数格式化范例
 paramsSerializer: function (params) {
    params = cloneDeep(params);
    const [startInstallTime, endInstallTime] = params.installTimes || [];
    const [startUpdateTimes, endUpdateTimes] = params.updateTimes || [];
    delete params.installTimes;
    delete params.updateTimes;
    Object.assign(params, {
      startInstallTime,
      endInstallTime,
      startUpdateTimes,
      endUpdateTimes
    })
    return QueryString.stringify(params)
  }
 */

// 请求定义位置
export const request: CustomRequest.request = {
  //打印项相关接口
  fragmentCreate: wrapRequest({ url: "/fragment", method: "post" }),
  fragmentUpdate: wrapRequest({ url: "/fragment/{id}", method: "put" }),
  fragmentEdit: wrapRequest({
    url: "/fragment/{temId}/version/{verId}/orgId/{id}",
    method: "put",
  }),
  fragmentDetail: wrapRequest(
    { url: "/fragment/{id}", method: "get" },
    function (data: Fragment.DetailResponse) {
      if (data.data.defaultVersion?.thumbnailPath) {
        data.data.defaultVersion.thumbnailPath =
          process.env.VUE_APP_DOWNLOAD_PREFIX +
          data.data.defaultVersion.thumbnailPath;
      }
      return data;
    }
  ),
  fragmentList: wrapRequest(
    {
      url: "/fragment",
      method: "get",
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: "comma" });
      },
    },
    function (data: Fragment.ListResponse) {
      data.data.forEach((item) => {
        if (item.defaultVersion?.thumbnailPath) {
          item.defaultVersion.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX +
            item.defaultVersion.thumbnailPath;
        }
      });
      return data;
    }
  ),
  fragmentHistoryVersionList: wrapRequest(
    {
      url: "/fragment/history",
      method: "get",
    },
    function (data: FragmentHistory.ListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
      });
      return data;
    }
  ),
  fragmentPublish: wrapRequest({ url: "/fragment/status", method: "put" }),
  //自定义区相关接口
  customCreate: wrapRequest({ url: "/template/area", method: "post" }),
  customList: wrapRequest(
    {
      url: "/template/area",
      method: "get",
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: "comma" });
      },
    },
    function (data: Custom.ListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
        // item.contentPath =
        //   process.env.VUE_APP_DOWNLOAD_PREFIX + item.contentPath;
        item.deliveryLogo =
          process.env.VUE_APP_DOWNLOAD_PREFIX + item.deliveryLogo;
      });
      return data;
    }
  ),
  customPublish: wrapRequest({
    url: "/template/area/status/{areaId}",
    method: "put",
  }),
  customHistoryVersionList: wrapRequest(
    {
      url: "/template/area/version",
      method: "get",
    },
    function (data: CustomHistory.ListResponse) {
      data.data.forEach((item) => {
        item.thumbnailPath =
          process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        // item.contentPath =
        //   process.env.VUE_APP_DOWNLOAD_PREFIX + item.contentPath;
      });
      return data;
    }
  ),
  customUpdate: wrapRequest({
    url: "/template/area/{areaId}",
    method: "put",
  }),
  customDetail: wrapRequest(
    {
      url: "/template/area/{areaId}",
      method: "get",
    },
    function (data: Custom.DetailResponse) {
      if (data.data.thumbnailPath) {
        data.data.thumbnailPath =
          process.env.VUE_APP_DOWNLOAD_PREFIX + data.data.thumbnailPath;
      }
      return data;
    }
  ),
  customRollback: wrapRequest({
    url: "/template/area/history/{templateId}/version/{versionId}",
    method: "put",
  }),
  standardList: wrapRequest(
    { url: "/template/common", method: "get" },
    function (data: Standard.ListResponse) {
      data.data.forEach((item) => {
        item.thumbnailPath =
          process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        item.deliveryLogo =
          process.env.VUE_APP_DOWNLOAD_PREFIX + item.deliveryLogo;
      });
      return data;
    }
  ),
  //用户相关接口
  userIdentitySwitch: wrapRequest({ url: "/identity", method: "put" }),
  userIdentityInfo: wrapRequest({ url: "/identity", method: "get" }),
  //服务相关接口
  serviceList: wrapRequest({ url: "/service", method: "get" }),
  serviceChoose: wrapRequest({ url: "/service/choose/{id}", method: "post" }),
  // 下载
  download: wrapRequest(
    {
      url: "/common/download",
      method: "get",
      responseType: "text",
    },
    undefined
  ),
  // 承运商列表
  expressList: wrapRequest({ url: "/delivery", method: "get" }, undefined),
  // 收藏相关
  collectList: wrapRequest({ url: "/collection/list", method: "get" }),
  collectAdd: wrapRequest({ url: "/collection/collect", method: "post" }),
  collectCancel: wrapRequest({ url: "/collection/unCollect", method: "post" }),
  deleteFake: wrapRequest({ url: "/recycle/deleteTemporary", method: "post" }),
  // 回收站相关接口
  recycleList: wrapRequest(
    { url: "/recycle/list", method: "get" },
    function (data: RecycleBin.recycleListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
        if (item.deliveryLogo) {
          item.deliveryLogo =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.deliveryLogo;
        }
      });
      return data;
    }
  ),
  recycleDelete: wrapRequest({
    url: "/recycle/deletePermanent",
    method: "post",
  }),
  recycleRestore: wrapRequest({
    url: "/recycle/restore",
    method: "post",
  }),
  // 自定义模板相关接口
  templateCreate: wrapRequest({ url: "/template", method: "post" }),
  templateList: wrapRequest(
    {
      url: "/template",
      method: "get",
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: "comma" });
      },
    },
    function (data: Template.ListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
      });
      return data;
    }
  ),
  isvFragmentList: wrapRequest({ url: "/fragment/isv", method: "get" }),
  templateCategoryList: wrapRequest(
    {
      url: "/template/category",
      method: "get",
    },
    // 产品要求一级分类不可以选择，后端接口一级分类未返回id等属性，因此前端自行添加id用于展示
    function (response: Template.CategoryListResponse) {
      response.data = response.data.map((item) => {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 1000000);
        return {
          id: `${timestamp}-${random}`,
          name: item.parent,
          parent: item.parent,
          children: item.children,
        };
      });
      return response;
    }
  ),
  templateIsv: wrapRequest(
    { url: "/template/isv", method: "get" },
    function (data: Template.ListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
      });
      return data;
    }
  ),
  templatePublish: wrapRequest({
    url: "/template/status/{templateId}",
    method: "put",
  }),
  templateUpdate: wrapRequest({
    url: "/template/{templateId}",
    method: "put",
  }),
  templateDetail: wrapRequest(
    {
      url: "/template/info/{templateId}",
      method: "get",
    },
    function (data: Template.DetailResponse) {
      if (data.data.thumbnailPath) {
        data.data.thumbnailPath =
          process.env.VUE_APP_DOWNLOAD_PREFIX + data.data.thumbnailPath;
      }
      return data;
    }
  ),
  templateHistoryVersionList: wrapRequest(
    {
      url: "/template/version",
      method: "get",
    },
    function (data: TemplateHistory.ListResponse) {
      data.data.forEach((item) => {
        if (item.thumbnailPath) {
          item.thumbnailPath =
            process.env.VUE_APP_DOWNLOAD_PREFIX + item.thumbnailPath;
        }
      });
      return data;
    }
  ),
  templateRollback: wrapRequest({
    url: "/template/history/{templateId}/version/{versionId}",
    method: "put",
  }),
  // 打印项版本回滚
  fragmentRollback: wrapRequest({
    url: "/fragment/{id}/history/{versionId}",
    method: "put",
  }),
  // 用户退出登录
  nodeServeLogout: wrapRequest(
    {
      url: "/logout",
      method: "get",
    },
    undefined,
    nodeInstance
  ),
  nodeServeToken: wrapRequest(
    {
      url: "/token",
      method: "get",
    },
    undefined,
    nodeInstance
  ),
};
